import React from "react";
import Panel from "../components/panels/panel";
import { useApi } from "utilities/hookutils";
import { ButtonTertiary } from "components/Atoms/Button";
import MapStateModal from "./MapStateModal";
import moment from "moment";

const StateAliasApp = () => {
  const [openMapStateModal, setOpenMapStateModal] = React.useState<server.dto.StateAlias | null>(null);

  const unmappedStateAliases = useApi(
    async () => window.CoreApi.StateAlias.ListUnmapped(),
    ["StateAlias.ListUnmapped"]
  );

  return <>
    {openMapStateModal !== null && <MapStateModal
      alias={openMapStateModal?.alias || ""}
      country={openMapStateModal?.country}
      handleClose={() => { setOpenMapStateModal(null); unmappedStateAliases.refetch(); }}
    />}
    <Panel
      title="Unmapped states"
      headerSize="h1"
      panelClassName="s1_listview-panel"
      isLoading={unmappedStateAliases.isLoading}
    >
      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          {unmappedStateAliases.data?.data?.map((stateAlias) => (
            <div key={stateAlias.alias}>
              <div style={{ flex: 1 }} className="flex-column gap-small">
                <span>{stateAlias.alias}</span>
                <span className="text-sublabel">{stateAlias.countryName}</span>
              </div>
              <div style={{ flex: 1 }}>
                {moment.utc(stateAlias.createdUtc).fromNow()}
              </div>
              <ButtonTertiary
                onClick={() => { setOpenMapStateModal(stateAlias); }}
                label="map this state"
              />
            </div>
          ))}
        </div>
      </div>
    </Panel>
  </>;
};

export default StateAliasApp;
